import {useContext} from "react";
import {SideNavigationContextState, ISideNavigationContext} from "../context/SideNavigationContext";

export const useSideNavigation = ()=>useContext<SideNavigationContextState>(ISideNavigationContext)